<template>
	<div style="overflow: clip;">
		<header>
			<NavBar />
		</header>
		<main>
			<div class="container">
				<NavBarButton />
				<slot />
			</div>
		</main>
		<Footer />
	</div>
</template>
